__turbopack_context__.v({
  "container": "feature-section-v2-module-scss-module__WcF5sq__container",
  "copyBottom": "feature-section-v2-module-scss-module__WcF5sq__copyBottom",
  "copyContainer": "feature-section-v2-module-scss-module__WcF5sq__copyContainer",
  "copyTop": "feature-section-v2-module-scss-module__WcF5sq__copyTop",
  "disclaimer": "feature-section-v2-module-scss-module__WcF5sq__disclaimer",
  "image": "feature-section-v2-module-scss-module__WcF5sq__image",
  "mediaContainer": "feature-section-v2-module-scss-module__WcF5sq__mediaContainer",
  "noCopy": "feature-section-v2-module-scss-module__WcF5sq__noCopy",
  "video": "feature-section-v2-module-scss-module__WcF5sq__video",
});
